/**
 * @auther Praneeth Geethanjana <geethanjana10@gmail.com>
 * @Since 5/10/2022
 */

import React from 'react';
import ReactPlayer  from "react-player";
import iframe from 'react-iframe';
import './Video.scss';
import videojs from "video.js";
import CustomYoutubePlayer from "../CustomYoutubePlayer/CustomYoutubePlayer";

export default class Player extends React.Component {

    state= {
        type:'',
        url:'',
    }

    componentDidMount() {
        this.setState({
            url:this.props.url,
            type:this.props.type,
        })
    }

    // <ReactPlayer id={"react-player"} height={400} width="100%" controls={true} url={this.state.url}/>

    render() {
        return (
            <div>
                {this.state.type === 'YOUTUBE' ?   <CustomYoutubePlayer url={this.state.url}/>:
                    <iframe id={"react-player"} allow={"autoplay"} height={400} width="100%" src={this.state.url}></iframe>}
            </div>

        )
    }
}